// components/WhatsAppFloatingButton.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const WhatsAppFloatingButton = () => {
  const whatsappNumber = "+254105938447"; // Replace with your number (country code + number, no '+')
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  const styles = {
    position: 'fixed',
    bottom: '20px',
    left: '20px',
    zIndex: 1000,
    backgroundColor: '#25D366',
    color: '#fff',
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
    textDecoration: 'none',
    fontSize: '30px',
  };

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      style={styles}
      aria-label="Chat on WhatsApp"
    >
     <FontAwesomeIcon icon={faWhatsapp} size="2x" />
    </a>
  );
};

export default WhatsAppFloatingButton;
